module.exports = __webpack_public_path__ + "img/boda-baile-1.b68a46ee.jpg";